<template>
  <v-app-bar elevation="0" app>
    <template v-slot:append>
      <v-btn class="d-none d-lg-flex" :prepend-icon="this.$phone_icon" :style="menuButtonStyle" variant="flat" href="/contact">Contact Us</v-btn>
      <v-btn v-if="!this.customer_id" class="d-none d-lg-flex" :prepend-icon="this.$signup_icon" :style="menuButtonStyle" variant="flat" href="/signup/">Sign Up</v-btn>
      <v-menu v-if="this.customer_id">
        <template v-slot:activator="{ props }">
          <v-btn class="d-none d-lg-flex" v-bind="props" :style="menuButtonStyle" variant="flat">
            <v-badge
                :color="this.color"
                :content="this.messageCount"
                class="me-2 d-none d-lg-flex"
                dot
            >
              <v-icon :icon="this.$account_icon" />
            </v-badge>
            My Account
          </v-btn>
        </template>
        <v-list>
          <v-list-item href="/account/" v-if="this.customer_id">Account</v-list-item>
          <v-list-item href="/account/notifications/" v-if="this.customer_id">Notifications</v-list-item>
          <v-list-item href="/logout/" v-if="this.customer_id">Logout</v-list-item>
        </v-list>
      </v-menu>
      <v-btn v-else class="d-none d-lg-flex" :prepend-icon="this.$account_icon" :style="menuButtonStyle" variant="flat" href="/login/">Login</v-btn>
      <cartComponent :key="this.cartKey" class="d-none d-lg-flex" />
      <v-app-bar-nav-icon class="d-flex d-lg-none" :color="this.$primary_color" variant="text" @click.stop="mobileDrawer = !mobileDrawer; drawer = false;" />
    </template>
  </v-app-bar>
  <v-app-bar class="v-bar" elevation="0">
    <template v-slot:prepend>
      <a  href="/"><img class="d-flex header-img ms-12" src="/images/HANDLE-Marketplace-Logo-800px.png" /></a>
    </template>
    <template v-slot:append>
      <v-btn class="d-none d-lg-flex" href="/quotebuilder" :style="menuButtonStyle" variant="flat">Buy Equipment</v-btn>
      <v-btn class="d-none d-lg-flex" href="/dispositions" :style="menuButtonStyle" variant="flat">Sell Equipment</v-btn>
      <v-btn class="d-none d-lg-flex" href="/buildouts" :style="menuButtonStyle" variant="flat">Buildouts</v-btn>
      <v-menu
          :close-on-content-click="false"
          location="bottom"
      >
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" :append-icon="this.$down_icon" :style="menuButtonStyle" variant="flat" class="d-none d-lg-flex">Categories</v-btn>
        </template>
        <category_menuComponent />
      </v-menu>
      <span class="d-none d-lg-flex mt-6">
        <v-text-field
            v-model="this.search"
            class="me-2"
            variant="outlined"
            min-width="400"
            max-width="700"
            density="compact"
            label="Search for Equipment"
            :prepend-inner-icon="this.$search_icon"
            @keyup.enter="assetSearch"
        />
      </span>
    </template>
  </v-app-bar>
  <v-navigation-drawer v-model="mobileDrawer" temporary location="right" class=" v-mobile-nav" app>
    <v-list class="v-nav" density="compact" nav>
      <v-text-field
          v-model="this.search"
          class="me-2"
          variant="outlined"
          density="compact"
          label="Search Products"
          @keyup.enter="this.assetSearch"
          clearable
      />
      <v-list-item value="home" href="/">
        Home
      </v-list-item>
      <v-tooltip text="View all Products">
        <template v-slot:activator="{ props }">
          <v-list-item value="products" href="/quotebuilder" v-bind="props">
            Buy Equipment
          </v-list-item>
        </template>
      </v-tooltip>
      <v-tooltip text="Room Buildouts">
        <template v-slot:activator="{ props }">
          <v-list-item value="buildouts" href="/buildouts" v-bind="props">
            Buildouts
          </v-list-item>
        </template>
      </v-tooltip>
      <v-tooltip text="Sell your products">
        <template v-slot:activator="{ props }">
          <v-list-item value="sell" href="/dispositions" v-bind="props">
            Sell Equipment
          </v-list-item>
        </template>
      </v-tooltip>
      <v-list-item v-if="this.messageCount > 0" value="account" href="/account">
        <v-badge :color="this.color" :content="this.messageCount" dot>My Account</v-badge>
      </v-list-item>
      <v-list-item v-else value="account" href="/account">
        My Account
      </v-list-item>
      <v-tooltip text="View your current product quote">
        <template v-slot:activator="{ props }">
          <v-list-item value="cart" href="/quotebuilder/checkout" v-bind="props">
            My Quote
          </v-list-item>
        </template>
      </v-tooltip>
      <v-list-item href="/contact">
        Contact Us
      </v-list-item>
      <v-list-item href="https://www.handleglobal.com" target="_blank">
        About
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import cartComponent from "@/components/cartComponent.vue";
import category_menuComponent from "@/components/form_elementComponents/category_menuComponent.vue";

export default {
  name: "menuComponent.vue",

  components: {
    cartComponent,
    category_menuComponent,
  },
  data () {
    return {
      customer_id: localStorage.getItem('id'),
      mobileDrawer: false,
      messageCount: 0,
      color: 'grey',
      search: '',
      cartKey: 0,
    }
  },
  computed: {
    menuButtonStyle() {
      return {
        backgroundColor: "#ffffff",
        color: this.$primary_color,
      };
    },
  },
  mounted() {
    this.getResults();
  },
  methods: {
    getResults(){
      const token = localStorage.getItem("token");
      const hasToken = token && token !== "undefined";

      if (hasToken) {
        this.axios.get(this.$csrf_url).then(
            this.axios.get(this.$main_api + "/notifications/unread", {
              headers: {
                'Authorization': 'Bearer ' + token,
              }
            })
                .then((response) => {
                  this.messageCount = response.data.messages;
                  if (this.messageCount > 0) {
                    this.color = 'red';
                  }
                })
                .catch((error) => {
                  if (error.response.status == 401) {
                    this.customer_id = '';
                  }
                })
        );
      }
    },
    assetSearch(){
      const search = this.search;
      this.search = '';
      //this.$router.push('/quotebuilder/?search=' + search);
      window.location.href="/quotebuilder/?search=" + search;
    },
  },
}
</script>

<style scoped>

</style>